// import React, { useState, useEffect } from "react";
// import { MapPin, Phone, ArrowRight } from "lucide-react";
// import { FaPen } from "react-icons/fa"; // For edit icon
// import  '../styles/contact.css'

// const ContactSection = ({ role }) => {
//   // States for contact section data
//   const [questionsHeading, setQuestionsHeading] = useState("Do You Have Questions?");
//   const [connectHeading, setConnectHeading] = useState("Let's connect!");
//   const [description1, setDescription1] = useState(
//     "When it's time to make your move in Las Vegas, California, you need a dedicated partner by your side. Brian Karsh, the best realtor in Las Vegas CA, is here to assist you in finding your perfect home. Serving not only Lafayette but also the neighboring communities of Moraga, Orinda, and Walnut Creek, Brian brings a wealth of local knowledge to the table."
//   );
//   const [description2, setDescription2] = useState(
//     "Whether you're interested in Living in Lafayette CA, Moraga CA, Orinda CA, or Walnut Creek CA, Brian Karsh is your go-to resource for all your real estate needs. Contact Brian today, and let him expertise guide you through the exciting journey of buying or selling a home in the East Bay."
//   );
//   const [phoneHeading, setPhoneHeading] = useState("Phone / Location");
//   const [email, setEmail] = useState("BK@BrianKarsh.com");
//   const [phone, setPhone] = useState("+1 720-737-2513");
//   const [address, setAddress] = useState("1646 N California Blvd Walnut Creek, CA 94596");
  
//   // Hardcoded form fields (not editable)
//   const formFields = {
//     help_label: "How can I help you?",
//     help_options: [
//       "I want to buy a home",
//       "I want to sell a home",
//       "I'm looking for information",
//       "Other"
//     ],
//     submit: "Submit"
//   };
  
//   const [featuredTitle, setFeaturedTitle] = useState(
//     "Looking for your dream home or thinking of selling?"
//   );
//   const [featuredDescription, setFeaturedDescription] = useState(
//     "Connect with Brian for insights and personalized advice on your property needs."
//   );
//   const [featuredButtonText, setFeaturedButtonText] = useState("Schedule a Consultation");
//   const [featuredImageUrl, setFeaturedImageUrl] = useState(
//     "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=2942&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
//   );

//   // Edit form states
//   const [showEditForm, setShowEditForm] = useState(false);
//   const [editData, setEditData] = useState({
//     questions_heading: "",
//     connect_heading: "",
//     description_1: "",
//     description_2: "",
//     phone_heading: "",
//     email: "",
//     phone: "",
//     address: "",
//     featured_title: "",
//     featured_description: "",
//     featured_button_text: "",
//     featured_image_url: ""
//   });

//   // Fetch contact section data from the server
//   useEffect(() => {
//     const fetchContactData = async () => {
//       try {
//         const response = await fetch("/api/get_contact_section", {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//           },
//         });
        
//         if (!response.ok) {
//           console.log(`Error status: ${response.status}`);
//           return; // Exit early and use default data
//         }
        
//         const data = await response.json();
        
//         // Update the state with fetched data
//         if (data) {
//           setQuestionsHeading(data.questions_heading || "");
//           setConnectHeading(data.connect_heading || "");
//           setDescription1(data.description_1 || "");
//           setDescription2(data.description_2 || "");
//           setPhoneHeading(data.phone_heading || "");
//           setEmail(data.email || "");
//           setPhone(data.phone || "");
//           setAddress(data.address || "");
//           setFeaturedTitle(data.featured_title || "");
//           setFeaturedDescription(data.featured_description || "");
//           setFeaturedButtonText(data.featured_button_text || "");
//           setFeaturedImageUrl(data.featured_image_url || "");
//         }
//       } catch (error) {
//         console.error("Error fetching contact section data:", error);
//       }
//     };

//     fetchContactData();
//   }, []);

//   // Handle edit button click
//   const handleEditClick = () => {
//     // Pre-fill the edit form with current values
//     setEditData({
//       questions_heading: questionsHeading,
//       connect_heading: connectHeading,
//       description_1: description1,
//       description_2: description2,
//       phone_heading: phoneHeading,
//       email: email,
//       phone: phone,
//       address: address,
//       featured_title: featuredTitle,
//       featured_description: featuredDescription,
//       featured_button_text: featuredButtonText,
//       featured_image_url: featuredImageUrl
//     });
    
//     setShowEditForm(true);
//   };

//   // Handle form input changes
//   const handleInputChange = (field, value) => {
//     setEditData(prev => ({
//       ...prev,
//       [field]: value
//     }));
//   };

//   // Handle save changes
//   const handleSaveChanges = async (e) => {
//     e.preventDefault();
    
//     try {
//       const response = await fetch("/api/save_contact_section", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//         body: JSON.stringify(editData),
//       });
      
//       if (!response.ok) {
//         const errorText = await response.text();
//         throw new Error(`Server error: ${response.status} - ${errorText}`);
//       }
      
//       // Update the component state with edited values
//       setQuestionsHeading(editData.questions_heading);
//       setConnectHeading(editData.connect_heading);
//       setDescription1(editData.description_1);
//       setDescription2(editData.description_2);
//       setPhoneHeading(editData.phone_heading);
//       setEmail(editData.email);
//       setPhone(editData.phone);
//       setAddress(editData.address);
//       setFeaturedTitle(editData.featured_title);
//       setFeaturedDescription(editData.featured_description);
//       setFeaturedButtonText(editData.featured_button_text);
//       setFeaturedImageUrl(editData.featured_image_url);
      
//       // Close the edit form
//       setShowEditForm(false);
      
//       alert("Contact section updated successfully!");
//     } catch (error) {
//       console.error("Error saving contact section:", error);
//       alert("Error saving changes: " + error.message);
//     }
//   };

//   return (
//     <div className="w-full bg-white relative">
//       {/* Edit button for owner */}
//       {role === "owner" && (
//         <button
//           onClick={handleEditClick}
//           className="absolute top-4 right-10 text-gray-500 hover:text-gray-700 z-10"
//           title="Edit Contact Section"
//         >
//           <FaPen size={24} />
//         </button>
//       )}
      
//       {/* Form and Connect Section */}
//       <div className="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//           {/* Left Column - Let's Connect */}
//           <div className="pr-4" data-aos="fade-right">
//             <div className="text-red-600 italic mb-2 font-medium">
//               {questionsHeading}
//             </div>
//             <h2 className="text-4xl font-bold mb-6">{connectHeading}</h2>

//             <div className="mb-8">
//               <p className="mb-4 text-justify text-gray-700 leading-relaxed">
//                 {description1}
//               </p>

//               <p className="mb-8 text-justify text-gray-700 leading-relaxed">
//                 {description2}
//               </p>
//             </div>

//             <div>
//               <h3 className="font-bold text-lg mb-4">{phoneHeading}</h3>

//               <div className="flex items-center mb-4">
//                 <div className="w-8 h-8 rounded-full bg-red-600 flex items-center justify-center mr-4">
//                   <Phone className="text-white" size={18} />
//                 </div>
//                 <div>
//                   <div>Email: {email}</div>
//                   <div>Mobile: {phone}</div>
//                 </div>
//               </div>

//               <div className="flex items-center">
//                 <div className="w-8 h-8 rounded-full bg-red-600 flex items-center justify-center mr-4">
//                   <MapPin className="text-white" size={18} />
//                 </div>
//                 <div>{address}</div>
//               </div>
//             </div>
//           </div>

//           {/* Right Column - Contact Form */}
//           <div
//             data-aos="fade-left"
//             className="bg-red-600 p-8 rounded-lg text-white"
//           >
//             <form>
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
//                 <input
//                   type="text"
//                   placeholder="First Name"
//                   className="p-3 border rounded text-black"
//                 />
//                 <input
//                   type="text"
//                   placeholder="Last Name"
//                   className="p-3 border rounded text-black"
//                 />
//               </div>

//               <div className="mb-4">
//                 <input
//                   type="email"
//                   placeholder="Email"
//                   className="w-full p-3 border rounded text-black"
//                 />
//               </div>

//               <div className="mb-4">
//                 <input
//                   type="tel"
//                   placeholder="Phone Number"
//                   className="w-full p-3 border rounded text-black"
//                 />
//               </div>

//               <div className="mb-4">
//                 <label className="block mb-2">{formFields.help_label}</label>
//                 <select className="w-full p-3 border rounded text-black">
//                   {formFields.help_options.map((option, index) => (
//                     <option key={index}>{option}</option>
//                   ))}
//                 </select>
//               </div>

//               <div className="mb-6">
//                 <textarea
//                   rows="4"
//                   placeholder="Type your message here"
//                   className="w-full p-3 border rounded text-black"
//                 ></textarea>
//               </div>

//               <button
//                 type="submit"
//                 className="bg-white text-black px-6 py-2 rounded-full flex items-center justify-center"
//               >
//                 {formFields.submit} <ArrowRight size={16} className="ml-2" />
//               </button>
//             </form>
//           </div>
//         </div>
//       </div>

//       {/* Featured Property Card */}
//       <div className="w-full bg-gray-100 py-12">
//         <div
//           className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8"
//           data-aos="zoom-out-up"
//         >
//           <div className="bg-white overflow-hidden shadow-lg rounded-lg">
//             <div className="grid grid-cols-1 md:grid-cols-2">
//               {/* Property Image */}
//               <div className="h-64 md:h-auto">
//                 <img
//                   src={featuredImageUrl}
//                   alt="Featured property"
//                   className="w-full h-full object-cover"
//                 />
//               </div>

//               {/* Property Info */}
//               <div className="bg-red-600 text-white p-8 flex flex-col justify-center">
//                 <h2 className="text-3xl font-bold mb-2 color" style={{color:'white'}}>
//                   {featuredTitle}
//                 </h2>
//                 <p className="mb-6 color">
//                   {featuredDescription}
//                 </p>
//                 <div>
//                   <button className="bg-white text-black px-6 py-3 rounded-full inline-flex items-center">
//                     {featuredButtonText}{" "}
//                     <ArrowRight size={16} className="ml-2" />
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Edit Form Modal */}
//       {showEditForm && (
//         <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 backdrop-blur-sm overflow-y-auto">
//           <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl w-full max-w-5xl relative">
//             {/* Modal header */}
//             <div className="flex justify-between items-center mb-6">
//               <h2 className="text-2xl font-bold dark:text-white">Edit Contact Section</h2>
//               <button
//                 onClick={() => setShowEditForm(false)}
//                 className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
//               >
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="24"
//                   height="24"
//                   fill="none"
//                   stroke="currentColor"
//                   strokeWidth="2"
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                 >
//                   <line x1="18" y1="6" x2="6" y2="18" />
//                   <line x1="6" y1="6" x2="18" y2="18" />
//                 </svg>
//               </button>
//             </div>

//             {/* Edit form */}
//             <form onSubmit={handleSaveChanges} className="max-h-[70vh] overflow-y-auto p-2">
//               <h3 className="text-xl font-bold mb-4 border-b pb-2 color">Left Column Content</h3>
              
//               <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1 color">
//                     Questions Heading
//                   </label>
//                   <input
//                     type="text"
//                     className="w-full border border-gray-300 rounded-md px-3 py-2"
//                     value={editData.questions_heading}
//                     onChange={(e) => handleInputChange("questions_heading", e.target.value)}
//                   />
//                 </div>
                
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1 color">
//                     Connect Heading
//                   </label>
//                   <input
//                     type="text"
//                     className="w-full border border-gray-300 rounded-md px-3 py-2"
//                     value={editData.connect_heading}
//                     onChange={(e) => handleInputChange("connect_heading", e.target.value)}
//                   />
//                 </div>
//               </div>

//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700 mb-1 color">
//                   Description 1
//                 </label>
//                 <textarea
//                   rows="3"
//                   className="w-full border border-gray-300 rounded-md px-3 py-2"
//                   value={editData.description_1}
//                   onChange={(e) => handleInputChange("description_1", e.target.value)}
//                 ></textarea>
//               </div>

//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700 mb-1 color">
//                   Description 2
//                 </label>
//                 <textarea
//                   rows="3"
//                   className="w-full border border-gray-300 rounded-md px-3 py-2"
//                   value={editData.description_2}
//                   onChange={(e) => handleInputChange("description_2", e.target.value)}
//                 ></textarea>
//               </div>

//               <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block text-sm font-medium text-white-700 mb-1 color ">
//                     Phone Heading
//                   </label>
//                   <input
//                     type="text"
//                     className="w-full border border-gray-300 rounded-md px-3 py-2"
//                     value={editData.phone_heading}
//                     onChange={(e) => handleInputChange("phone_heading", e.target.value)}
//                   />
//                 </div>
                
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1 color">
//                     Email
//                   </label>
//                   <input
//                     type="text"
//                     className="w-full border border-gray-300 rounded-md px-3 py-2"
//                     value={editData.email}
//                     onChange={(e) => handleInputChange("email", e.target.value)}
//                   />
//                 </div>
//               </div>

//               <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1 color">
//                     Phone
//                   </label>
//                   <input
//                     type="text"
//                     className="w-full border border-gray-300 rounded-md px-3 py-2"
//                     value={editData.phone}
//                     onChange={(e) => handleInputChange("phone", e.target.value)}
//                   />
//                 </div>
                
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1 color">
//                     Address
//                   </label>
//                   <input
//                     type="text"
//                     className="w-full border border-gray-300 rounded-md px-3 py-2"
//                     value={editData.address}
//                     onChange={(e) => handleInputChange("address", e.target.value)}
//                   />
//                 </div>
//               </div>

//               <h3 className="text-xl font-bold mb-4 mt-8 border-b pb-2 color">Featured Property Card</h3>
              
//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700 mb-1 color">
//                   Title
//                 </label>
//                 <input
//                   type="text"
//                   className="w-full border border-gray-300 rounded-md px-3 py-2 color"
//                   value={editData.featured_title}
//                   onChange={(e) => handleInputChange("featured_title", e.target.value)}
//                 />
//               </div>

//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700 mb-1 color">
//                   Description
//                 </label>
//                 <textarea
//                   rows="2"
//                   className="w-full border border-gray-300 rounded-md px-3 py-2 color"
//                   value={editData.featured_description}
//                   onChange={(e) => handleInputChange("featured_description", e.target.value)}
//                 ></textarea>
//               </div>

//               <div className="mb-4">
//                 <label className="block text-sm font-medium text-gray-700 mb-1 color">
//                   Button Text
//                 </label>
//                 <input
//                   type="text"
//                   className="w-full border border-gray-300 rounded-md px-3 py-2"
//                   value={editData.featured_button_text}
//                   onChange={(e) => handleInputChange("featured_button_text", e.target.value)}
//                 />
//               </div>

//               <div className="mb-6">
//                 <label className="block text-sm font-medium text-gray-700 mb-1 color">
//                   Image URL
//                 </label>
//                 <input
//                   type="text"
//                   className="w-full border border-gray-300 rounded-md px-3 py-2"
//                   value={editData.featured_image_url}
//                   onChange={(e) => handleInputChange("featured_image_url", e.target.value)}
//                 />
//               </div>

//               {/* Form buttons */}
//               <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700 sticky bottom-0 bg-white dark:bg-gray-800 p-2">
//                 <button
//                   type="button"
//                   onClick={() => setShowEditForm(false)}
//                   className="px-4 py-2 rounded-md text-gray-700 bg-gray-200 hover:bg-gray-300 transition-colors duration-150 focus:outline-none dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 "
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="submit"
//                   className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors duration-150 focus:outline-none"
//                 >
//                   Save Changes
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ContactSection;





















import React, { useState, useEffect } from "react";
import { MapPin, Phone, ArrowRight } from "lucide-react";
import { FaPen } from "react-icons/fa"; // For edit icon
import  '../styles/contact.css'

const ContactSection = ({ role }) => {
  // States for contact section data
  const [questionsHeading, setQuestionsHeading] = useState("Do You Have Questions?");
  const [connectHeading, setConnectHeading] = useState("Let's connect!");
  const [description1, setDescription1] = useState(
    "When it's time to make your move in Las Vegas, California, you need a dedicated partner by your side. Brian Karsh, the best realtor in Las Vegas CA, is here to assist you in finding your perfect home. Serving not only Lafayette but also the neighboring communities of Moraga, Orinda, and Walnut Creek, Brian brings a wealth of local knowledge to the table."
  );
  const [description2, setDescription2] = useState(
    "Whether you're interested in Living in Lafayette CA, Moraga CA, Orinda CA, or Walnut Creek CA, Brian Karsh is your go-to resource for all your real estate needs. Contact Brian today, and let him expertise guide you through the exciting journey of buying or selling a home in the East Bay."
  );
  const [phoneHeading, setPhoneHeading] = useState("Phone / Location");
  const [email, setEmail] = useState("Loading...");
  const [phone, setPhone] = useState("Loading...");
  const [address, setAddress] = useState("Loading...");
  const backendUrl = 'https://python-backend-68898252993.us-central1.run.app';

  // Hardcoded form fields (not editable)
  const formFields = {
    help_label: "How can I help you?",
    help_options: [
      "I want to buy a home",
      "I want to sell a home",
      "I'm looking for information",
      "Other"
    ],
    submit: "Submit"
  };
  
  const [featuredTitle, setFeaturedTitle] = useState(
    "Looking for your dream home or thinking of selling?"
  );
  const [featuredDescription, setFeaturedDescription] = useState(
    "Connect with Brian for insights and personalized advice on your property needs."
  );
  const [featuredButtonText, setFeaturedButtonText] = useState("Schedule a Consultation");
  const [featuredImageUrl, setFeaturedImageUrl] = useState(
    "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=2942&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
  );

  // Edit form states
  const [showEditForm, setShowEditForm] = useState(false);
  const [editData, setEditData] = useState({
    questions_heading: "",
    connect_heading: "",
    description_1: "",
    description_2: "",
    phone_heading: "",
    email: "",
    phone: "",
    address: "",
    featured_title: "",
    featured_description: "",
    featured_button_text: "",
    featured_image_url: ""
  });

  // Fetch contact section data from the server
  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await fetch(`${backendUrl}/api/get_contact_section`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        });
        
        if (!response.ok) {
          console.log(`Error status: ${response.status}`);
          return; // Exit early and use default data
        }
        
        const data = await response.json();
        
        // Update the state with fetched data
        if (data) {
          setQuestionsHeading(data.questions_heading || "");
          setConnectHeading(data.connect_heading || "");
          setDescription1(data.description_1 || "");
          setDescription2(data.description_2 || "");
          setPhoneHeading(data.phone_heading || "");
          setEmail(data.email || "");
          setPhone(data.phone || "");
          setAddress(data.address || "");
          setFeaturedTitle(data.featured_title || "");
          setFeaturedDescription(data.featured_description || "");
          setFeaturedButtonText(data.featured_button_text || "");
          setFeaturedImageUrl(data.featured_image_url || "");
        }
      } catch (error) {
        console.error("Error fetching contact section data:", error);
      }
    };

    fetchContactData();
  }, []);

  // Handle edit button click
  const handleEditClick = () => {
    // Pre-fill the edit form with current values
    setEditData({
      questions_heading: questionsHeading,
      connect_heading: connectHeading,
      description_1: description1,
      description_2: description2,
      phone_heading: phoneHeading,
      email: email,
      phone: phone,
      address: address,
      featured_title: featuredTitle,
      featured_description: featuredDescription,
      featured_button_text: featuredButtonText,
      featured_image_url: featuredImageUrl
    });
    
    setShowEditForm(true);
  };

  // Handle form input changes
  const handleInputChange = (field, value) => {
    setEditData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  // Handle save changes
  const handleSaveChanges = async (e) => {
    e.preventDefault();
    
    try {
      const response = await fetch(`${backendUrl}/api/save_contact_section`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify(editData),
      });
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Server error: ${response.status} - ${errorText}`);
      }
      
      // Update the component state with edited values
      setQuestionsHeading(editData.questions_heading);
      setConnectHeading(editData.connect_heading);
      setDescription1(editData.description_1);
      setDescription2(editData.description_2);
      setPhoneHeading(editData.phone_heading);
      setEmail(editData.email);
      setPhone(editData.phone);
      setAddress(editData.address);
      setFeaturedTitle(editData.featured_title);
      setFeaturedDescription(editData.featured_description);
      setFeaturedButtonText(editData.featured_button_text);
      setFeaturedImageUrl(editData.featured_image_url);
      
      // Close the edit form
      setShowEditForm(false);
      
      alert("Contact section updated successfully!");
    } catch (error) {
      console.error("Error saving contact section:", error);
      alert("Error saving changes: " + error.message);
    }
  };

  return (
    <div className="w-full bg-white relative">
      {/* Edit button for owner */}
      {role === "owner" && (
        <button
          onClick={handleEditClick}
          className="absolute top-4 right-10 text-gray-500 hover:text-gray-700 z-10"
          title="Edit Contact Section"
        >
          <FaPen size={24} />
        </button>
      )}
      
      {/* Form and Connect Section */}
      <div className="max-w-6xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Column - Let's Connect */}
          <div className="pr-4" data-aos="fade-right">
            <div className="text-red-600 italic mb-2 font-medium">
              {questionsHeading}
            </div>
            <h2 className="text-4xl font-bold mb-6">{connectHeading}</h2>

            <div className="mb-8">
              <p className="mb-4 text-justify text-gray-700 leading-relaxed">
                {description1}
              </p>

              <p className="mb-8 text-justify text-gray-700 leading-relaxed">
                {description2}
              </p>
            </div>

            <div>
              <h3 className="font-bold text-lg mb-4">{phoneHeading}</h3>

              <div className="flex items-center mb-4">
                <div className="w-8 h-8 rounded-full bg-red-600 flex items-center justify-center mr-4">
                  <Phone className="text-white" size={18} />
                </div>
                <div>
                  <div>Email: {email}</div>
                  <div>Mobile: {phone}</div>
                </div>
              </div>

              <div className="flex items-center">
                <div className="w-8 h-8 rounded-full bg-red-600 flex items-center justify-center mr-4">
                  <MapPin className="text-white" size={18} />
                </div>
                <div>{address}</div>
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div
            data-aos="fade-left"
            className="bg-red-600 p-8 rounded-lg text-white"
          >
            <form>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <input
                  type="text"
                  placeholder="First Name"
                  className="p-3 border rounded text-black"
                />
                <input
                  type="text"
                  placeholder="Last Name"
                  className="p-3 border rounded text-black"
                />
              </div>

              <div className="mb-4">
                <input
                  type="email"
                  placeholder="Email"
                  className="w-full p-3 border rounded text-black"
                />
              </div>

              <div className="mb-4">
                <input
                  type="tel"
                  placeholder="Phone Number"
                  className="w-full p-3 border rounded text-black"
                />
              </div>

              <div className="mb-4">
                <label className="block mb-2">{formFields.help_label}</label>
                <select className="w-full p-3 border rounded text-black">
                  {formFields.help_options.map((option, index) => (
                    <option key={index}>{option}</option>
                  ))}
                </select>
              </div>

              <div className="mb-6">
                <textarea
                  rows="4"
                  placeholder="Type your message here"
                  className="w-full p-3 border rounded text-black"
                ></textarea>
              </div>

              <button
                type="submit"
                className="bg-white text-black px-6 py-2 rounded-full flex items-center justify-center"
              >
                {formFields.submit} <ArrowRight size={16} className="ml-2" />
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Featured Property Card */}
      <div className="w-full bg-gray-100 py-12">
        <div
          className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8"
          data-aos="zoom-out-up"
        >
          <div className="bg-white overflow-hidden shadow-lg rounded-lg">
            <div className="grid grid-cols-1 md:grid-cols-2">
              {/* Property Image */}
              <div className="h-64 md:h-auto">
                <img
                  src={featuredImageUrl}
                  alt="Featured property"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Property Info */}
              <div className="bg-red-600 text-white p-8 flex flex-col justify-center">
                <h2 className="text-3xl font-bold mb-2 color" style={{color:'white'}}>
                  {featuredTitle}
                </h2>
                <p className="mb-6 color">
                  {featuredDescription}
                </p>
                <div>
                  <button className="bg-white text-black px-6 py-3 rounded-full inline-flex items-center">
                    {featuredButtonText}{" "}
                    <ArrowRight size={16} className="ml-2" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Edit Form Modal */}
      {showEditForm && (
        <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4 backdrop-blur-sm overflow-y-auto">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl w-full max-w-5xl relative">
            {/* Modal header */}
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold dark:text-white">Edit Contact Section</h2>
              <button
                onClick={() => setShowEditForm(false)}
                className="text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>

            {/* Edit form */}
            <form onSubmit={handleSaveChanges} className="max-h-[70vh] overflow-y-auto p-2">
              <h3 className="text-xl font-bold mb-4 border-b pb-2 color">Left Column Content</h3>
              
              <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1 color">
                    Questions Heading
                  </label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                    value={editData.questions_heading}
                    onChange={(e) => handleInputChange("questions_heading", e.target.value)}
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1 color">
                    Connect Heading
                  </label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                    value={editData.connect_heading}
                    onChange={(e) => handleInputChange("connect_heading", e.target.value)}
                  />
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1 color">
                  Description 1
                </label>
                <textarea
                  rows="3"
                  className="w-full border border-gray-300 rounded-md px-3 py-2"
                  value={editData.description_1}
                  onChange={(e) => handleInputChange("description_1", e.target.value)}
                ></textarea>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1 color">
                  Description 2
                </label>
                <textarea
                  rows="3"
                  className="w-full border border-gray-300 rounded-md px-3 py-2"
                  value={editData.description_2}
                  onChange={(e) => handleInputChange("description_2", e.target.value)}
                ></textarea>
              </div>

              <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-white-700 mb-1 color ">
                    Phone Heading
                  </label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                    value={editData.phone_heading}
                    onChange={(e) => handleInputChange("phone_heading", e.target.value)}
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1 color">
                    Email
                  </label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                    value={editData.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                  />
                </div>
              </div>

              <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1 color">
                    Phone
                  </label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                    value={editData.phone}
                    onChange={(e) => handleInputChange("phone", e.target.value)}
                  />
                </div>
                
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1 color">
                    Address
                  </label>
                  <input
                    type="text"
                    className="w-full border border-gray-300 rounded-md px-3 py-2"
                    value={editData.address}
                    onChange={(e) => handleInputChange("address", e.target.value)}
                  />
                </div>
              </div>

              <h3 className="text-xl font-bold mb-4 mt-8 border-b pb-2 color">Featured Property Card</h3>
              
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1 color">
                  Title
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-md px-3 py-2 color"
                  value={editData.featured_title}
                  onChange={(e) => handleInputChange("featured_title", e.target.value)}
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1 color">
                  Description
                </label>
                <textarea
                  rows="2"
                  className="w-full border border-gray-300 rounded-md px-3 py-2 color"
                  value={editData.featured_description}
                  onChange={(e) => handleInputChange("featured_description", e.target.value)}
                ></textarea>
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1 color">
                  Button Text
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-md px-3 py-2"
                  value={editData.featured_button_text}
                  onChange={(e) => handleInputChange("featured_button_text", e.target.value)}
                />
              </div>

              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1 color">
                  Image URL
                </label>
                <input
                  type="text"
                  className="w-full border border-gray-300 rounded-md px-3 py-2"
                  value={editData.featured_image_url}
                  onChange={(e) => handleInputChange("featured_image_url", e.target.value)}
                />
              </div>

              {/* Form buttons */}
              <div className="flex justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700 sticky bottom-0 bg-white dark:bg-gray-800 p-2">
                <button
                  type="button"
                  onClick={() => setShowEditForm(false)}
                  className="px-4 py-2 rounded-md text-gray-700 bg-gray-200 hover:bg-gray-300 transition-colors duration-150 focus:outline-none dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 "
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 rounded-md bg-blue-600 text-white hover:bg-blue-700 transition-colors duration-150 focus:outline-none"
                >
                  Save Changes
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactSection;